/* The NewLab – Cart Drawer "Seyahat Boy Hediye Seçici"
   Be Yours 8.4.0 mini-cart (cart-drawer) için. Footer'ın en üstüne, ÖDEME butonunun üstüne yerleşir.
   - Hediye yokken: başlık + küçük yatay ürün şeridi
   - Hediye seçilince: tek satırlık onay ("✓ Hediyen: ... · Değiştir")
   - Değiştir: eski hediyeyi çıkarıp yenisini ekler (müşteri sepetten silmekle uğraşmaz)
   0 TL olma işi Shopify indirim kampanyasıyla yapılır. */
(function () {
  if (window.__tnlGiftDrawer) return; window.__tnlGiftDrawer = true;

  var CFG = {
    collection: 'seyahat-boy-cilt-bakim-urunleri',
    title: 'Seyahat boy hediyeni seç',
    note: 'Ücretsiz',
    lineProperty: { '_Hediye': 'Seyahat Boy' }
  };

  var products = [], giftIds = new Set(), cart = null, busy = false, open = false;

  function shortName(t) {
    return t.replace(/\s*Seyahat Boy\s*$/i, '').replace(/\s*\d+\s*ml\s*$/i, '');
  }
  function img(p) {
    var s = p.images[0] ? p.images[0].src : '';
    return s ? s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
  }

  function css() {
    if (document.getElementById('tnl-dg-css')) return;
    var s = document.createElement('style'); s.id = 'tnl-dg-css';
    s.textContent = `
    .tnl-dg{margin:0 0 14px;border:1px solid #f0dcb8;background:#fffaf2;border-radius:6px;font-family:inherit;overflow:hidden}
    .tnl-dg__bar{display:flex;align-items:center;gap:8px;width:100%;padding:10px 12px;background:none;border:0;cursor:pointer;text-align:left;font:inherit;color:#7a4a00}
    .tnl-dg__ico{font-size:15px;line-height:1}
    .tnl-dg__txt{flex:1;font-size:12.5px;font-weight:600;letter-spacing:.01em;line-height:1.3}
    .tnl-dg__txt small{display:block;font-weight:400;font-size:11px;color:#9a7a4a;margin-top:1px}
    .tnl-dg__chev{font-size:11px;transition:transform .2s;color:#b07a2a}
    .tnl-dg.is-open .tnl-dg__chev{transform:rotate(180deg)}
    .tnl-dg__panel{display:none;padding:0 12px 12px}
    .tnl-dg.is-open .tnl-dg__panel{display:block}
    .tnl-dg__track{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding-bottom:2px}
    .tnl-dg__track::-webkit-scrollbar{display:none}
    .tnl-dg__item{flex:0 0 82px;scroll-snap-align:start;background:#fff;border:1px solid #efe3cf;border-radius:6px;padding:6px;display:flex;flex-direction:column;align-items:center;text-align:center}
    .tnl-dg__item.is-on{border-color:#1a1b18;box-shadow:0 0 0 1px #1a1b18}
    .tnl-dg__item img{width:52px;height:52px;object-fit:contain;margin-bottom:4px}
    .tnl-dg__name{font-size:10.5px;line-height:1.3;color:#1a1b18;height:41px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;margin-bottom:6px}
    .tnl-dg__add{width:100%;border:0;border-radius:3px;background:#1a1b18;color:#fff;font:inherit;font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;padding:6px 2px;cursor:pointer}
    .tnl-dg__add:hover{opacity:.85}
    .tnl-dg__add[disabled]{cursor:default;opacity:1}
    .tnl-dg__item.is-on .tnl-dg__add{background:#2f7d4f}
    .tnl-dg.has-gift{border-color:#cfe5d6;background:#f4faf6}
    .tnl-dg.has-gift .tnl-dg__bar{color:#2f7d4f}
    .tnl-dg.has-gift .tnl-dg__txt small{color:#5d8a6d}
    .tnl-dg__chg{font-size:11px;text-decoration:underline;color:#2f7d4f;white-space:nowrap}
    .tnl-dg__slider{position:relative}
    .tnl-dg__track{cursor:grab}
    .tnl-dg__track.is-drag{cursor:grabbing;scroll-snap-type:none}
    .tnl-dg__track.is-drag *{pointer-events:none}
    .tnl-dg__arr{position:absolute;top:20px;z-index:2;width:28px;height:28px;border-radius:50%;border:1px solid #e6d3b3;background:#fff;color:#1a1b18;box-shadow:0 2px 8px rgba(0,0,0,.12);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:opacity .15s}
    .tnl-dg__arr svg{width:12px;height:12px}
    .tnl-dg__arr:hover{background:#1a1b18;color:#fff;border-color:#1a1b18}
    .tnl-dg__arr--prev{left:-6px}
    .tnl-dg__arr--next{right:-6px}
    .tnl-dg__arr[hidden]{display:none}
    .tnl-dg__dots{display:flex;justify-content:center;gap:4px;margin-top:8px}
    .tnl-dg__dots i{width:5px;height:5px;border-radius:50%;background:#e6d3b3;transition:background .2s,width .2s}
    .tnl-dg__dots i.on{background:#7a4a00;width:14px;border-radius:3px}
    @media (hover:none){.tnl-dg__arr{display:none}}
    `;
    document.head.appendChild(s);
  }

  function state() {
    var gl = cart.items.filter(function (i) { return giftIds.has(i.variant_id); });
    var others = cart.items.filter(function (i) { return !giftIds.has(i.variant_id); });
    return { giftLines: gl, hasOthers: others.length > 0 };
  }

  function render() {
    var footer = document.querySelector('#mini-cart .mini-cart__footer');
    var box = document.querySelector('#mini-cart .tnl-dg');
    if (!footer || !cart || !products.length) return;
    var st = state();
    if (!st.hasOthers) { if (box) box.remove(); return; }       // sepette sadece hediye varsa / boşsa gösterme

    var gift = st.giftLines[0];
    var scroll = box ? (box.querySelector('.tnl-dg__track') || {}).scrollLeft || 0 : 0;
    if (!box) { box = document.createElement('div'); box.className = 'tnl-dg'; footer.insertBefore(box, footer.firstChild); }

    var isOpen = gift ? open : true;                         // hediye yokken şerit açık, varsa kapalı (Değiştir ile açılır)
    box.classList.toggle('has-gift', !!gift);
    box.classList.toggle('is-open', isOpen);

    var bar = gift
      ? '<span class="tnl-dg__ico">✓</span><span class="tnl-dg__txt">Hediyen sepette<small>' + shortName(gift.product_title) + '</small></span><span class="tnl-dg__chg">' + (isOpen ? 'Kapat' : 'Değiştir') + '</span>'
      : '<span class="tnl-dg__ico">🎁</span><span class="tnl-dg__txt">' + CFG.title + '<small>Birini seç, siparişine ücretsiz eklensin</small></span>';

    var list = products.map(function (p) {
      var v = p.variants.find(function (x) { return x.available; });
      var on = gift && p.variants.some(function (x) { return x.id === gift.variant_id; });
      return '<div class="tnl-dg__item' + (on ? ' is-on' : '') + '">' +
        '<img loading="lazy" src="' + img(p) + '" alt="">' +
        '<div class="tnl-dg__name">' + shortName(p.title) + '</div>' +
        '<button type="button" class="tnl-dg__add" data-id="' + v.id + '"' + (on ? ' disabled' : '') + '>' +
        (on ? '✓ Seçili' : (gift ? 'Değiş' : 'Ekle')) + '</button></div>';
    }).join('');

    box.innerHTML = '<button type="button" class="tnl-dg__bar"' + (gift ? '' : ' tabindex="-1"') + '>' + bar + '</button>' +
      '<div class="tnl-dg__panel"><div class="tnl-dg__slider">' +
      '<button type="button" class="tnl-dg__arr tnl-dg__arr--prev" data-dir="-1" aria-label="Önceki" hidden>' + ARR_L + '</button>' +
      '<div class="tnl-dg__track">' + list + '</div>' +
      '<button type="button" class="tnl-dg__arr tnl-dg__arr--next" data-dir="1" aria-label="Sonraki" hidden>' + ARR_R + '</button>' +
      '</div><div class="tnl-dg__dots"></div></div>';
    var tr = box.querySelector('.tnl-dg__track');
    if (tr) { tr.scrollLeft = scroll; setupTrack(tr); }
  }

  var ARR_L = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M7.5 2 3.5 6l4 4"/></svg>';
  var ARR_R = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4.5 2l4 4-4 4"/></svg>';

  // Okların görünürlüğü + sayfa noktaları
  function updateNav(tr) {
    var box = tr.closest('.tnl-dg'); if (!box) return;
    var max = tr.scrollWidth - tr.clientWidth;
    box.querySelector('.tnl-dg__arr--prev').hidden = tr.scrollLeft <= 2;
    box.querySelector('.tnl-dg__arr--next').hidden = tr.scrollLeft >= max - 2;
    var pages = max > 2 ? Math.ceil(tr.scrollWidth / tr.clientWidth) : 0;
    var dots = box.querySelector('.tnl-dg__dots');
    var cur = max > 0 ? Math.round(tr.scrollLeft / max * (pages - 1)) : 0;
    if (dots.children.length !== pages) dots.innerHTML = new Array(pages + 1).join('<i></i>');
    [].forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === cur); });
  }

  // Masaüstü: fare tekerleği yatay kaydırsın + sürükleyerek kaydırma
  function setupTrack(tr) {
    updateNav(tr);
    tr.addEventListener('scroll', function () { updateNav(tr); }, { passive: true });
    // Drawer kapalıyken genişlik 0 ölçülür; açılınca okları/noktaları yeniden hesapla
    if (window.ResizeObserver) new ResizeObserver(function () { updateNav(tr); }).observe(tr);
    tr.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;             // trackpad yatay kaydırma zaten çalışıyor
      var max = tr.scrollWidth - tr.clientWidth;
      if ((e.deltaY > 0 && tr.scrollLeft >= max - 1) || (e.deltaY < 0 && tr.scrollLeft <= 0)) return;
      e.preventDefault();
      tr.scrollLeft += e.deltaY;
    }, { passive: false });
    tr.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { tr: tr, x: e.clientX, l: tr.scrollLeft, moved: false };
    });
  }

  var drag = null;
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) { drag.moved = true; drag.tr.classList.add('is-drag'); }
    if (drag.moved) drag.tr.scrollLeft = drag.l - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!drag) return;
    var d = drag; drag = null;
    if (d.moved) setTimeout(function () { d.tr.classList.remove('is-drag'); }, 0);
  });

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }

  function choose(id, btn) {
    if (busy) return; busy = true;
    btn.textContent = '…'; btn.disabled = true;
    var old = state().giftLines;
    // Önce varsa eski hediyeyi çıkar, sonra yenisini ekle
    var chain = old.reduce(function (pr, line) {
      return pr.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 }) });
      });
    }, Promise.resolve());
    chain.then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: CFG.lineProperty }] }) });
    }).then(function (r) { if (!r.ok) throw r; })
      .then(function () { open = false; return getCart(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Tekrar dene'; })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var arr = e.target.closest('.tnl-dg__arr');
    if (arr) {
      e.preventDefault();
      var tr = arr.parentNode.querySelector('.tnl-dg__track');
      return tr.scrollBy({ left: Number(arr.dataset.dir) * (tr.clientWidth - 40), behavior: 'smooth' });
    }
    var add = e.target.closest('.tnl-dg__add');
    if (add && !add.disabled) { e.preventDefault(); return choose(add.dataset.id, add); }
    var bar = e.target.closest('.tnl-dg.has-gift .tnl-dg__bar');
    if (bar) { e.preventDefault(); open = !open; render(); }
  });

  // Tema her sepet değişiminde #mini-cart'ı baştan çiziyor -> bileşeni geri koy
  var t;
  function watch() {
    var mc = document.getElementById('mini-cart');
    if (!mc) return;
    new MutationObserver(function (muts) {
      if (muts.every(function (m) { return m.target.closest && m.target.closest('.tnl-dg'); })) return;
      clearTimeout(t);
      t = setTimeout(function () { if (!busy) getCart().then(render); }, 150);
    }).observe(mc, { childList: true, subtree: true });
  }

  function init() {
    css(); watch();
    fetch('/collections/' + CFG.collection + '/products.json?limit=50')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        products = d.products.filter(function (p) { return p.variants.some(function (v) { return v.available; }); });
        d.products.forEach(function (p) { p.variants.forEach(function (v) { giftIds.add(v.id); }); });
        return getCart();
      }).then(render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
